// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"201":"6196726d","206":"b532d038","219":"c8bb3669","367":"041df0fe","453":"a0428772","461":"b8b1b4cc","532":"7caee2f6","765":"75755a09","833":"3ef45a6d","929":"66d60367"}[chunkId] + ".chunk.js";
};